// extracted by mini-css-extract-plugin
export default {"link":"rO-z","disabled":"sO-z"};